<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click.stop="editRecord"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click.stop="confirmDeleteRecord"
    />
  </div>
</template>

<script>
export default {
  name: 'CellActions',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    editRecord() {
      this.$router.push({ name: 'system-user-edit', params: { id: this.user.id } }).catch(() => {})
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('messages.are_you_sure'),
        text: this.$t('messages.confirm_delete', {
          title: `${this.$t('users.account')} "${this.user.username}"`
        }),
        accept: this.deleteRecord,
        acceptText: this.$t('button.delete'),
        cancelText: this.$t('button.cancel')
      })
    },
    deleteRecord() {
      this.showDeleteSuccess()

      this.$store.dispatch('userManagement/removeUser', this.user.id).then(() => {
        //update users list
        this.$store.dispatch('userManagement/fetchUsers')
        this.$store.dispatch('userManagement/countUsers')
        this.showDeleteSuccess()
      })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: this.$t('forms.successfully_deleted')
      })
    }
  }
}
</script>
